import type { Discipline, SkillId } from '../ids.ts';

export const skills: { id: SkillId; name: string; discipline: Discipline; icon: string }[] = [
  { id: 'archery', name: 'Archery', discipline: 'martial', icon: 'archery-target' },
  { id: 'jousting', name: 'Jousting', discipline: 'martial', icon: 'mounted-knight' },
  { id: 'horsemanship', name: 'Horsemanship', discipline: 'martial', icon: 'horse-head' },
  { id: 'hunting', name: 'Hunting', discipline: 'martial', icon: 'hunting-horn' },
  { id: 'mining', name: 'Mining', discipline: 'craft', icon: 'mine-wagon' },
  { id: 'woodcutting', name: 'Woodcutting', discipline: 'craft', icon: 'axe-in-stump' },
  { id: 'smithing', name: 'Smithing', discipline: 'craft', icon: 'anvil' },
  { id: 'engineering', name: 'Engineering', discipline: 'craft', icon: 'trebuchet' },
  { id: 'lockpicking', name: 'Lockpicking', discipline: 'cunning', icon: 'lockpicks' },
  { id: 'gambling', name: 'Gambling', discipline: 'cunning', icon: 'rolling-dices' },
  { id: 'cardSharping', name: 'Card sharping', discipline: 'cunning', icon: 'card-ace-spades' },
  { id: 'haggling', name: 'Haggling', discipline: 'cunning', icon: 'trade' },
  { id: 'alchemy', name: 'Alchemy', discipline: 'cloister', icon: 'round-bottom-flask' },
  { id: 'illumination', name: 'Illumination', discipline: 'cloister', icon: 'quill-ink' },
  { id: 'brewing', name: 'Brewing', discipline: 'cloister', icon: 'barrel' },
  { id: 'fishing', name: 'Fishing', discipline: 'cloister', icon: 'fishing-pole' },
];
